const data = require('./raw/glassData.json')

if (process.env.NODE_ENV === 'development') {
  // Add some items with testing values
  data.push(
    {
      id: 'test-tableware',
      title: 'TEST TABLEWARE',
      mainImage: '00000000-0000-0000-0000-000000000000',
      images: ['00000000-0000-0000-0000-000000000000'],
      description: 'TEST DESCRIPTION',
      data: {
        glassType: 'TABLEWARE',
        patternNumber: 'PATTERN NUMBER',
        colour: 'COLOUR',
        designer: 'DESIGNER',
        year: 'YEAR',
        tablewareType: 'Cup',
        productionMethod: 'MILLEFIORI',
        productionLocation: 'LONDON',
      },
      relatedItems: [
        'barkVase-cinnamon',
        'barkVase-kingfisher',
        'barkVase-tangerine',
      ],
    },
    {
      id: 'test-window',
      title: 'TEST WINDOW',
      mainImage: '00000000-0000-0000-0000-000000000000',
      images: ['00000000-0000-0000-0000-000000000000'],
      description: 'TEST DESCRIPTION',
      data: {
        glassType: 'WINDOW',
        location: 'LOCATION',
        designer: 'DESIGNER',
        year: 'YEAR',
        productionMethod: 'DALLEDEVERRE',
        productionLocation: 'LONDON',
      },
      relatedItems: ['all-saints'],
    }
  );
}

export const dataByIds = data.reduce(
  (result, item) => Object.assign(result, { [item.id]: item }),
  {}
);

export default data;



// WEBPACK FOOTER //
// ./data/glassData.js